import React, { Component } from 'react';
import { connect } from 'react-redux';

import Util from '../util';
import { setStorage,getStorage,onMiniProgramDialog } from '../common';
import { getSupperFundHome,getwebLogin,querySuperFundAccAgreement,superFundAccAgreementState,querySuperfundUpdateList,upgradeControl,smSzt } from '../action/investmentAction';
import { hashHistory } from 'react-router';
import { clearYlOne, clearSmrzOne ,signSuperFundAccAgreement, getRcommendStrategy,getSuperFundSeriesFun,isExpiredByInvestment} from "../action/investmentAction.js";
import { Toast } from 'antd-mobile/lib';
import {goLogin,querySuperFundAccAgreementStatus,goPubQuestionnaires,judgeQuestionnaires,hasConvertingTrade} from '../getPay';

import { AlerModleQy,AlerModleCommon,AlerModleUpgrade } from './fundDetail/AlerModle';
import { myInvestmentList } from '../action/myAssets/InvestPlanAction';
import ModalSelectTip from './Modal/ModalSelectTip';
import { traceSave } from "../action/riskInPayAction.js";
import { GuidePageType } from "./guidePage/index.js";
import CacheHOC from "./HOC/StateCache.js"

const width = window.screen.width;

let ua=navigator.userAgent.toLowerCase()

function getQueryUrlFun(variable) {
  let _url = window.location.href;
  if(_url && _url.split("#/").length == 2 && _url.split("#/")[1] === "") {
    _url = _url.split("#/")[0];
  }
  if(_url.indexOf("?") != -1) {
     var query = _url.split("?")[1];
     var vars = query.split("&");
     for (var i=0;i<vars.length;i++) {
             var pair = vars[i].split("=");
             if(pair[0] == variable){return pair[1];}
     }
     return 9999;
  }else {
    return 9999;
  }
}
window.setCookie=function(name,value)
{
  var Days = 30;
  var exp = new Date();
  exp.setTime(exp.getTime() + Days*24*60*60*1000);
  document.cookie = name + "="+ escape (value) + ";expires=" + exp.toGMTString();
}
class Investment extends Component{
  constructor(props) {
    super(props);
    this.state={
      arr:[],
      localStorage:'没有登录',
      oldlocalStorage:JSON.stringify(window.localStorage),
      dataSouse:'接口',
      hideFlag:false,
      upgradeFlag:true,
      disupgradeFlag:false,
      disAgreeAlertFlag:false,
      sqAlerFlag:true,
      upgradeList:[],
      upgradeListAll:[],
      firstFlag:false,
      ifMakePlan: false,  //是否做了规划
      isAnswerState: false,  //题目、答案是否变更
      showHidePlanFlag: true, //默认展开
      riskModalFir: false,  //风险提示
      riskModalSec: false,  //风险提示
      riskMakeFlag: false, // 重新测评
      showFundFlag: false, //显示基金列表
      userAnswerList: [], //用户规划答案
      allStrategyList: [],
      partMateStrategyList: [],
      riskMatchSuperFundSeries: [],
      allSuperFundSeries: [],
      mateFundList: [],
      nothingFlagFir: false,
      nothingFlagSec: false,
      sceneVoList: [],
      seriesId: "",
      seriesName: "",
      modalXai: false,
      riskMakeSecFlag: false,
      questionModal: false,
      // thisText: "",
      flag: navigator.userAgent.toLowerCase()
    }
  }
  async componentWillMount(){
    // let a = Util.return_Clinet_Type();
    // console.log(a);
    sessionStorage.setItem('home_url',window.location.hash)
    window._czc.push(["_trackEvent", "华夏财富H5", "查理智投", "进入查理智投"]);
    let { dispatch } = this.props;
    document.title= "华夏查理智投";
    if (ua.indexOf("amcfmapp")>-1) {
      let isFirst=window.sessionStorage.getItem('no-first');//重启打开app第一次进入智投，第一次进入清空localStorage缓存，并更改sessStorage进入状态
      
      if (isFirst) {
       
      } else {
        window.clearLocalStorage();
        // Toast.info('第一次进入,清空缓存');
        window.sessionStorage.setItem('no-first',true);
      }
      let amcuid=getQueryUrlFun("data")
      let amcuid2= await getStorage("amcuid2")
      let stoken=getQueryUrlFun("appId")
      // setTimeout(() => {
      //   this.setState({
      //     thisText: "URL: " +  window.location.href + "data: " + amcuid + ", appId: " + stoken + ", cookie: " + document.cookie + ", uaNav: " + ua
      //   });
      // }, 2000)
      if (amcuid==amcuid2) {//对比两次进入 是否是同一个用户（包括空用户）
        let localStorage_token= await getStorage('loginInfo-longToken');
        if (localStorage_token!=9999) {
          // alert('同一个账户有长token');
          // this.setState({
          //   localStorage:JSON.stringify(window.localStorage),
          // })
          dispatch(getSupperFundHome({},(data)=>{
            this.haveFund(data)
            this.isExpiredByInvestmentFun();
          },this))
        } else{
          if (amcuid!=9999) {
          // alert('同一个账户没有长token，且外部登录')
            dispatch(getwebLogin({
              data:amcuid,
              appId:stoken
            },(result)=>{
              setStorage('amcuid2',amcuid);
              // this.setState({
              //   dataSouse:JSON.stringify(result),
              //   localStorage:JSON.stringify(window.localStorage),
              // })
              dispatch(getSupperFundHome({},(data)=>{this.haveFund(data)},this))
              this.isExpiredByInvestmentFun();
            }));
          } 
        }
      }else {
        //不是同一个账户，有amcuid获取接口，没有代表未登录
        window.clearLocalStorage();
        if (amcuid!=9999) {
          // alert('不是同一个账户，外部登录')
          dispatch(getwebLogin({
            data:amcuid,
            appId:stoken
          },(result)=>{
            setStorage('amcuid2',amcuid);
            // this.setState({
            //     dataSouse:JSON.stringify(result),
            //     localStorage:JSON.stringify(window.localStorage),
            //   })
            dispatch(getSupperFundHome({},(data)=>{this.haveFund(data)},this))
            this.isExpiredByInvestmentFun();
          }));
        } 
      }
    }else{
      dispatch(getSupperFundHome({},(data)=>{
        this.haveFund(data)
        this.isExpiredByInvestmentFun();
      },this))
    }
  }
  async haveFund(SupperFundHome){
    // this.setState({
    //   dataSouse:JSON.stringify(SupperFundHome)
    // })
    let arr=[]
    if(SupperFundHome){
      //有持仓
      if(SupperFundHome.singleSuperFundViews){
        SupperFundHome.singleSuperFundViews.map((item,key) =>{
          arr.push(item.superFundCode)
        })
      try{
          let getTimeFlag = window.localStorage.getItem("TimeTagQy");
          if(getTimeFlag){
            let d = new Date();
            if(d.getTime() > getTimeFlag){
              let AccAgreementStatus = await querySuperFundAccAgreementStatus()
              console.log(AccAgreementStatus,"AccAgreementStatusAccAgreementStatus")
              if(AccAgreementStatus === null || AccAgreementStatus === ''){
                  this.props.dispatch(superFundAccAgreementState(true))
              }
              let nextDay = new Date(new Date().setHours(0,0,0,0))/1000 + 86400;
              window.localStorage.setItem("TimeTagQy", nextDay*1000)
            }
          }else{
            
            // 记录次日0点时间戳
            let nextDay = new Date(new Date().setHours(0,0,0,0))/1000 + 86400;
            window.localStorage.setItem("TimeTagQy",nextDay*1000 );
            let AccAgreementStatus = await querySuperFundAccAgreementStatus()
            console.log(AccAgreementStatus,"AccAgreementStatusAccAgreementStatus")
            if(AccAgreementStatus === null || AccAgreementStatus.state === '0'){
                this.props.dispatch(superFundAccAgreementState(true))
            }
          }
          Toast.hide()
        }catch(err){
          console.log(err)
        } 
        //获取智投组合可转换
        try{
          this.props.dispatch(querySuperFundAccAgreement({},(res)=>{
            console.log(res);
          }));
          this.props.dispatch(querySuperfundUpdateList((res)=>{
            let arr=[];
            for(let i=0; i<res.length;i++){
              arr.push(res[i].superFundName)
            }
            this.setState({
              upgradeList:arr,
              upgradeListAll:res
            })
            console.log(res)
            if (res.length>0) {
              console.log('弹升级窗')
              let upgradeTime = window.localStorage.getItem("UpgradeTime");
              if (upgradeTime) {
                console.log('已存过时间')
                let d=new Date();
                if (d.getTime() > upgradeTime) {
                  this.props.dispatch(upgradeControl(true))
                } else {
                  this.props.dispatch(upgradeControl(false))
                }
              } else {
                console.log('没存时间，首次弹')
                this.props.dispatch(upgradeControl(true));
              }
            } else {
              this.props.dispatch(upgradeControl(false));
              console.log('不弹升级')
            }
          }));
        }catch(err){
          console.log(err);
        }
      }
      
    }
    this.setState({
      arr:arr
    })
  }
  chooseDataFun = (arr) => {
    let _count = false;
    if(arr && arr.length > 0) {
      for(let i = 0; i < arr.length; i++) {
        if(arr[i].superFundProductViewList && arr[i].superFundProductViewList.length > 0) {
          _count = true;
          break;
        }
        if(arr[i].superFundList && arr[i].superFundList.length > 0) {
          _count = true;
          break;
        }
      }
    }
    return _count;
  }
  chooseDataSecFun = (arr) => {
    if((arr && arr.length === 0) || !arr) {
      return true;
    }else {
      let _count = true;
      if(arr && arr.length > 0) {
        for(let i = 0; i < arr.length; i++) {
          if(arr[i].superFundProductViewList && arr[i].superFundProductViewList.length > 0) {
            _count = false;
            break;
          }
          if(arr[i].superFundList && arr[i].superFundList.length > 0) {
            _count = false;
            break;
          }
        }
      }
      return _count;
    }
  }
  sessionKyc = () => {
    let loadSourceBySup = sessionStorage.getItem('loadSourceBySup');
    let loadSourceByZt = sessionStorage.getItem('loadSourceByZt');
    if((loadSourceBySup == "全部" || loadSourceBySup == "部分") && loadSourceByZt !== "true") {
      // Toast.loading();
      this.props.dispatch(getSuperFundSeriesFun({}, (suc) => {
        console.log(suc);
        if(suc && suc.content) {
          // Toast.hide();
          if(loadSourceBySup == "全部") {
            if(this.chooseDataFun(suc.content.allSuperFundSeries)) {
              this.setState({
                seriesId: suc.content.allSuperFundSeries && suc.content.allSuperFundSeries.length > 0 ? suc.content.allSuperFundSeries[0].seriesId : "",
                seriesName: suc.content.allSuperFundSeries && suc.content.allSuperFundSeries.length > 0 ? suc.content.allSuperFundSeries[0].seriesName : "",
                mateFundList: suc.content.allSuperFundSeries ? suc.content.allSuperFundSeries : []
              }, () => {
                this.setState({
                  showHidePlanFlag: false,
                  showFundFlag: true
                });
              });
            }
          }else {
            if(this.chooseDataFun(suc.content.riskMatchSuperFundSeries)) {
              this.setState({
                mateFundList: suc.content.riskMatchSuperFundSeries ? suc.content.riskMatchSuperFundSeries : [],
                seriesId: suc.content.riskMatchSuperFundSeries && suc.content.riskMatchSuperFundSeries.length > 0 ? suc.content.riskMatchSuperFundSeries[0].seriesId : "",
                seriesName: suc.content.riskMatchSuperFundSeries && suc.content.riskMatchSuperFundSeries.length > 0 ? suc.content.riskMatchSuperFundSeries[0].seriesName : ""
              }, () => {
                this.setState({
                  showHidePlanFlag: false,
                  showFundFlag: true
                });
              });
            }
          }
        }else {
          // Toast.hide();
        }
      }));
    }else {
      if(loadSourceByZt === "true") {
        this.goResultFun(false);
        sessionStorage.setItem('loadSourceByZt', "false");
      }
    }
  }
  async componentDidMount(){
    if(this.props.location.query.inviteCode){
      window.localStorage.setItem("inviteCode", this.props.location.query.inviteCode);
    }
    let data = {
      superFundCode:"SF1015"
    }
    let zhongXin = sessionStorage.getItem('home_url');
    if(sessionStorage.getItem('first_enter')==null && (zhongXin && zhongXin.indexOf('venderType')>-1) ){
      this.setState({
        firstFlag:true
      })
    }
    //kyc缓存基金列表
    this.sessionKyc();
    this.props.dispatch(smSzt(0))
  }
  componentWillUnmount(){
    window._czc.push(["_trackEvent", "华夏财富H5", "查理智投", "离开查理智投"]);
  }
  goSuperFundList(){
    if(ua.indexOf("amcfmapp")>-1) {
      return;
    }
    window._czc.push(["_trackEvent", "华夏财富H5", "查理智投", "点击智投总金额"]);
    let data = this.props.SupperFundHome.singleSuperFundViews;
    hashHistory.push({
        pathname:'/SuperFundList',
        state:{name:'调整组合',type:1,data},
        query: {code:''}
    })
  }
  // goTransitRecords(){
  //   window._czc.push(["_trackEvent", "华夏财富H5", "查理智投", "点击再涂资金"]);
  //   hashHistory.push({
  //     pathname: "/TransitRecords"
  //   })
  // }
  handleDisagree(){
    // Toast.hide();
    this.props.dispatch(superFundAccAgreementState(false))
    this.props.dispatch(myInvestmentList({code:'',message:'',content:{records:[]}} ))
    this.setState({
      disAgreeAlertFlag:true,
      // sqAlerFlag:false
    })
  }
  handleArgee(){
    this.props.dispatch(superFundAccAgreementState(false))
    // this.props.dispatch(myInvestmentList({code:'',message:'',content:{records:[]}} ))
    this.props.dispatch(signSuperFundAccAgreement(
      { state:1,operator:"user"},
      (res)=>{
        console.log(res,"签约回调")
      this.props.dispatch(querySuperFundAccAgreement())
        // this.setState({
        //   agreeAlertFlag:true
        // })
      }
    ))
  }
//   //知道了
//  closeAgreeAlert(){
//     this.setState({
//       agreeAlertFlag:false
//     })
  // }
  //二级不同意签约
  closeDisAgreeAlert(){
    this.props.dispatch(superFundAccAgreementState(false))
    this.setState({
      disAgreeAlertFlag:false
    })
  }
  callBackQy(){
    this.props.dispatch(superFundAccAgreementState(true));
    this.setState({ sqAlerFlag:true,disAgreeAlertFlag:false })
  }
  /*立即升级 */
  pushUpdate(){
    let{upgradeListAll} = this.state;
    let superFundCode = upgradeListAll[0].superFundCode;
      let targetFundList = upgradeListAll[0].targetFundList;
      let amount = upgradeListAll[0].totalAmount;
      console.log(targetFundList,"targetFundList",amount)

      let fun = () => {
        Toast.loading();
        hasConvertingTrade({
          superFundCode: superFundCode
        }, () => {
          Toast.hide()
        }, () => {
          Toast.hide()
        })
        .then((suc) =>{
          if(suc === true) {
            Toast.show('当前智投组合有转换在途交易，该操作暂停', Util.ToastTime);
            return;
          }
          
          hashHistory.push({
            pathname: '/TransferF',
            state:{
              type:1,//调整组合,
              targetFundList:targetFundList,
              amount,
              superFundCode
            },
            query:{
              targetFundList:targetFundList,
              amount,
              superFundCode
            }
          });

        })
        .catch((err) => {
          Toast.hide();
          return;
        });
      };
      goLogin(fun, window.history.length);

      
  }
  /* 暂不升级*/
  handleCancleUpgrade(){
    this.props.dispatch(upgradeControl(false))
    this.setState({
      disupgradeFlag:true,
      // upgradeFlag:false
    })
  }
  /*返回升级页面 */
  handleBackUpgrade(){
    this.props.dispatch(upgradeControl(true))
    this.setState({
      disupgradeFlag:false
    })
  }
  /** 挽留不同意 */
  handleNoUpgrade() {
    // 记录次日0点时间戳
    let nextDay = new Date(new Date().setHours(0,0,0,0))/1000 + 86400;
    window.localStorage.setItem("UpgradeTime",nextDay*1000 );
    this.setState({
      disupgradeFlag:false
    })
  }
  RiskTest(){
    hashHistory.push({
      pathname:'/ChooseGh'
    })
  }
  pushInvestmentPlan(){
   window.location.href = "https://www.amcfortune.com/minipage/zdt/app/index.html";
  }
  pushZTJS() {
    // window.location.href = "https://app.amcfortune.com/wAppStatic/h5/video.html";
    hashHistory.push({
      pathname:'/Understand'
    })
  }
  pushWz() {
    // hashHistory.push({
    //   pathname:'/iframeWeb',
    //   query:{
    //     url:'https://wx.xinmeikuang.com/start/huaxia/h5/20190531/index'
    //   }
    // })
    window.location.href = "https://wx.xinmeikuang.com/start/huaxia/h5/20190531/index";
  }
  showHidePlan = () => {
    this.setState({
      showHidePlanFlag: !this.state.showHidePlanFlag
    });
  }
  showRiskMakeFunFir = () => {
    this.props.dispatch(traceSave({action: 'SF_SPECIAL_TIP', message: '用户查看部分智投产品时间: ' + new Date().toLocaleString()}));
    if(this.chooseDataSecFun(this.state.partMateStrategyList)) {
      this.setState({
        riskModalFir: false,
        riskMakeSecFlag: true
      });
    }else {
      this.showAllFundListFir(true, this.state.partMateStrategyList, "部分");
    }
  }
  resetRiskFun = () => {
    this.setState({
      riskMakeFlag: false
    });
    goPubQuestionnaires(hashHistory, window.history.length, ()=>{

    });
  }
  showAllFundListFir = (flag, data, name) => {
    this.props.dispatch(traceSave({action: 'SF_SPECIAL_TIP', message: '用户查看全部智投产品时间: ' + new Date().toLocaleString()}));
    if(flag === true) {
      this.setState({
        riskModalFir: false
      });
    }
    if(this.chooseDataFun(data)) {
      const tabListArr = [];
      for(let i = 0; i < this.state.sceneVoList.length; i++) {
        let _count = 0;
        let _countSec = 0;
        for(let s = 0; s < data.length; s++) {
          if(data[s].superFundProductViewList && data[s].superFundProductViewList.length > 0) {
            _countSec = _countSec - 0 + 1;
            if(this.state.sceneVoList[i].sceneId != data[s].sceneId) {
              _count = _count - 0 + 1;
            }
          }
        }
        if(_count == _countSec && _count > 0) {
          tabListArr.push(this.state.sceneVoList[i].sceneName);
        }
      }
      console.log(tabListArr);
      hashHistory.push({
        pathname:'/MakePlanResult',
        state: {
          fundListArr: data,
          tabListArr: tabListArr,
          lookFlag: name,
          rootPath: "Investment"
        }
      });
    }
  }
  goToMakePlan = async () => {
    Toast.loading();
    let flagDigital=await getStorage('loginState');
    let _currentUserInfo = await getStorage('currentUserInfo');
    console.log(flagDigital, _currentUserInfo)
    if(flagDigital!='0' && !_currentUserInfo.isRealName){
      const isMiniProgram = onMiniProgramDialog(GuidePageType.OpenAccount)
      if (isMiniProgram) return
    }
    if(flagDigital == '1'){
      //实名认证
      this.props.dispatch(clearSmrzOne())
      Toast.hide()
      hashHistory.push({
          pathname:'/CertificationUpload',
          state:{
            route:window.history.length,
            phoneNo:_currentUserInfo && _currentUserInfo.mobileNo ? _currentUserInfo.mobileNo : "",
            callback:ua.indexOf("amcfmapp") > -1 ? ()=>{this.goToMakePlan()} : null
          }
      })
      return;
    }else if(flagDigital=='3'){
      Toast.hide()
      //同步开户
      hashHistory.push({
          pathname:'/BindingMobile',
          state:{route:window.history.length,callback:()=>{this.goToMakePlan()}}
      })
      return;
    }else if(flagDigital=='0'){
      Toast.hide()
      hashHistory.push({
          pathname: ua.indexOf("amcfmapp") > -1 ? '/LoginHxjj' : '/Login',
          state:{route:window.history.length,callback:ua.indexOf("amcfmapp") > -1 ? ()=>{this.goToMakePlan()} : null}
      })
      return;
    }else {
      Toast.hide();
      let didQuestionnairs = false;
      try{
        didQuestionnairs = await judgeQuestionnaires();
      }catch(err){
        return;
      }
      if(!didQuestionnairs) {
        this.setState({
          questionModal: true
        });
        return;
      }
      let currentUserInfo= await getStorage('currentUserInfo');
      console.log(currentUserInfo);
      if(currentUserInfo && currentUserInfo.userMsg) {
        hashHistory.push({
          pathname:'/MakePlanDetail',
          state: {
            certNo: currentUserInfo.userMsg.certType === "0" && currentUserInfo.userMsg.certNo ? currentUserInfo.userMsg.certNo : ""
          }
        });
      }
    }
  }
  isExpiredByInvestmentFun = async () => {
    let _func = () => {
      this.props.dispatch(isExpiredByInvestment({}, (res) => {
        console.log(res);
        this.setState({
          ifMakePlan: res.content.planed,
          isAnswerState: res.content.expried,
          userAnswerList: []
        });
        if(res.content.questionnaire && res.content.questionnaire.questionList && res.content.questionnaire.questionList.length > 0) {
          let dataSource = [].concat(res.content.questionnaire.questionList);
          let newDataSource = [].concat(this.state.userAnswerList);
          for(let i = 0; i < dataSource.length; i++) {
            const _title = dataSource[i].content;
            const _order = dataSource[i].order;
            let _content = "";
            if(dataSource[i].order == "1") {
              _content = dataSource[i].userOption ? new Date().getFullYear() - dataSource[i].userOption : "";
            }
            if(dataSource[i].order == "2") {
              const newData = [];
              for(let s = 0; s < dataSource[i].optionList.length; s++) {
                if(dataSource[i].userOption.indexOf(dataSource[i].optionList[s].order) != -1) {
                  newData.push({
                    flag: true,
                    content: dataSource[i].optionList[s].content
                  });
                }else {
                  newData.push({
                    flag: false,
                    content: dataSource[i].optionList[s].content
                  });
                }
              }
              _content = newData;
            }
            // if(dataSource[i].order == "3") {
            //   for(let s = 0; s < dataSource[i].optionList.length; s++) {
            //     if(dataSource[i].userOption == dataSource[i].optionList[s].order) {
            //       _content = dataSource[i].optionList[s].content == "是" ? true : false;
            //     }
            //   }
            // }
            // newDataSource.push({
            //   order: _order,
            //   title: _title,
            //   content: _content
            // });
            if(dataSource[i].order != "3") {
              newDataSource.push({
                order: _order,
                title: _title,
                content: _content
              });
            }
          }
          console.log(newDataSource);
          this.setState({
            userAnswerList: newDataSource
          });
        }
      }));
    }
    if(ua.indexOf("amcfmapp") > -1) {
      _func();
    }else {
      let flagDigital=await getStorage('loginState');
      if(flagDigital=='0') {

      }else {
        _func();
      }
    }
  }
  goResultFun = async (val) => {
    Toast.loading();
    let flagDigital=await getStorage('loginState');
    let _currentUserInfo = await getStorage('currentUserInfo');
    console.log(flagDigital, _currentUserInfo)
    if(flagDigital!='0' && !_currentUserInfo.isRealName){
      const isMiniProgram = onMiniProgramDialog(GuidePageType.OpenAccount)
      if (isMiniProgram) return
    }
    if(flagDigital == '1'){
      //实名认证
      this.props.dispatch(clearSmrzOne())
      Toast.hide()
      hashHistory.push({
          pathname:'/CertificationUpload',
          state:{
            route:window.history.length,
            phoneNo:_currentUserInfo && _currentUserInfo.mobileNo ? _currentUserInfo.mobileNo : "",
            callback:ua.indexOf("amcfmapp") > -1 ? ()=>{this.goResultFun(val)} : null
          }
      })
      return;
    }else if(flagDigital=='3'){
      Toast.hide()
      //同步开户
      hashHistory.push({
          pathname:'/BindingMobile',
          state:{route:window.history.length,callback:()=>{this.goResultFun(val)}}
      })
      return;
    }else if(flagDigital=='0'){
      Toast.hide()
      hashHistory.push({
          pathname: ua.indexOf("amcfmapp") > -1 ? '/LoginHxjj' : '/Login',
          state:{route:window.history.length,callback:ua.indexOf("amcfmapp") > -1 ? ()=>{this.goResultFun(val)} : null}
      })
      return;
    }else {
      Toast.hide();
      let didQuestionnairs = false;
      try{
        didQuestionnairs = await judgeQuestionnaires();
      }catch(err){
        return;
      }
      if(!didQuestionnairs) {
        this.setState({
          questionModal: true
        });
        return;
      }
      Toast.loading();
      if(val === true) {
        this.setState({
          allStrategyList: [],
          partMateStrategyList: [],
          sceneVoList: []
        });
        this.props.dispatch(getRcommendStrategy({}, (suc) => {
          console.log(suc);
          if(suc && suc.content) {
            Toast.hide();
            this.setState({
              sceneVoList: suc.content.sceneVoList
            }, () => {
              if(suc.content.mateAll === true) {
                if(this.chooseDataSecFun(suc.content.allStrategyList)) {
                  this.setState({
                    nothingFlagFir: true
                  });
                }else {
                  //匹配直接跳转
                  this.showAllFundListFir(false, suc.content.allStrategyList ? suc.content.allStrategyList : [], "全部");
                }
              }else {
                //不匹配 一个也没有
                if(this.chooseDataSecFun(suc.content.allStrategyList)) {
                  this.setState({
                    nothingFlagFir: true
                  });
                }else {
                  this.setState({
                    riskModalFir: true,
                    allStrategyList: suc.content.allStrategyList ? suc.content.allStrategyList : [],
                    partMateStrategyList: suc.content.partMateStrategyList ? suc.content.partMateStrategyList : []
                  });
                }
              }
            });
          }else {
            Toast.hide();
          }
        }));
      }else {
        this.setState({
          allSuperFundSeries: [],
          riskMatchSuperFundSeries: []
        });
        this.props.dispatch(getSuperFundSeriesFun({}, (suc) => {
          console.log(suc);
          if(suc && suc.content) {
            Toast.hide();
            if(suc.content.mateAll === true) {
              if(this.chooseDataSecFun(suc.content.allSuperFundSeries)) {
                this.setState({
                  nothingFlagSec: true
                });
              }else {
                //匹配直接跳转
                this.showAllFundListSec(suc.content.allSuperFundSeries ? suc.content.allSuperFundSeries : []);
              }
            }else {
              //不匹配 一个也没有
              if(this.chooseDataSecFun(suc.content.allSuperFundSeries)) {
                this.setState({
                  nothingFlagSec: true
                });
              }else {
                this.setState({
                  riskModalSec: true,
                  allSuperFundSeries: suc.content.allSuperFundSeries ? suc.content.allSuperFundSeries : [],
                  riskMatchSuperFundSeries: suc.content.riskMatchSuperFundSeries ? suc.content.riskMatchSuperFundSeries : []
                });
              }
            }
          }else {
            Toast.hide();
          }
        }));
      }
    }
  }
  showRiskMakeFunSec = () => {
    this.props.dispatch(traceSave({action: 'SF_SPECIAL_TIP', message: '用户查看部分智投产品时间: ' + new Date().toLocaleString()}));
    if(this.chooseDataSecFun(this.state.riskMatchSuperFundSeries)) {
      this.setState({
        riskModalSec: false,
        riskMakeFlag: true
      });
    }else {
      this.setState({
        mateFundList: this.state.riskMatchSuperFundSeries,
        seriesId: this.state.riskMatchSuperFundSeries.length > 0 ? this.state.riskMatchSuperFundSeries[0].seriesId : "",
        seriesName: this.state.riskMatchSuperFundSeries.length > 0 ? this.state.riskMatchSuperFundSeries[0].seriesName : ""
      }, () => {
        if(this.chooseDataFun(this.state.riskMatchSuperFundSeries)) {
          this.setState({
            riskModalSec: false,
            showHidePlanFlag: false,
            showFundFlag: true
          });
          sessionStorage.setItem('loadSourceBySup', "部分");
        }
      });
    }
  }
  showAllFundListSec = (data) => {
    this.props.dispatch(traceSave({action: 'SF_SPECIAL_TIP', message: '用户查看全部智投产品时间: ' + new Date().toLocaleString()}));
    this.setState({
      allSuperFundSeries: data ? data : this.state.allSuperFundSeries,
      mateFundList: data ? data : this.state.allSuperFundSeries,
      seriesId: data && data.length > 0 ? data[0].seriesId : this.state.allSuperFundSeries.length > 0 ? this.state.allSuperFundSeries[0].seriesId : "",
      seriesName: data && data.length > 0 ? data[0].seriesName : this.state.allSuperFundSeries.length > 0 ? this.state.allSuperFundSeries[0].seriesName : "",
      riskModalSec: false
    }, () => {
      if(data) {
        if(this.chooseDataFun(data)) {
          this.setState({
            riskModalSec: false,
            showHidePlanFlag: false,
            showFundFlag: true
          });
          sessionStorage.setItem('loadSourceBySup', "全部");
        }
      }else {
        if(this.chooseDataFun(this.state.allSuperFundSeries)) {
          this.setState({
            riskModalSec: false,
            showHidePlanFlag: false,
            showFundFlag: true
          });
          sessionStorage.setItem('loadSourceBySup', "全部");
        }
      }
    });
  }
  ckTab = (id, name) => {
    this.setState({
      seriesId: id,
      seriesName: name
    });
  }
  investNotDetil = (data) => {
    if(ua.indexOf("amcfmapp")>-1) {
      // window.location.href = "http://mtest.chinaamc.com/huaXiaCaiFu/fullMarketTouguDetailPage/index.html?fundCode=" + data.superFundCode;//测试
      if(data.superFundCode == 'SF1022'){
        window.location.href = "https://m.chinaamc.com/huaXiaCaiFu/touguDetailPage/index.html?fundCode=" + data.superFundCode;//生产
      }else{
         window.location.href = "https://m.chinaamc.com/huaXiaCaiFu/fullMarketTouguDetailPage/index.html?fundCode=" + data.superFundCode;//生产
      }
      return;
    }
    let pathName = "/SuperFundDetail";
    if(data.fundType === "1") {
      pathName = '/TargetProfitDetail';
    }else {
      pathName = '/SuperFundDetail';
    }

    hashHistory.push({
      pathname:pathName,
        state:{superFundName:data.superFundName,superFundCode:data.superFundCode},
        query: {superFundName:data.superFundName,superFundCode:data.superFundCode}
    })
  }
  showModalXiaoai = () => {
    this.setState({
      modalXai: true
    });
    let obj = document.getElementsByTagName("html")[0];
    obj.style.overflowY = "hidden";
    obj.addEventListener("touchmove", this.touchMove, false);
  }
  closeModalXai = () => {
    this.setState({
      modalXai: false
    });
    let obj = document.getElementsByTagName("html")[0];
    obj.style.overflowY = "auto";
    obj.removeEventListener("touchmove", this.touchMove, false);
  }
  hideQuestionModal = () => {
    this.setState({
      questionModal: false
    });
  }
  quertionModalFun = () => {
    this.setState({
      questionModal: false
    });
    goPubQuestionnaires(hashHistory, window.history.length, ()=>{
      
    });
  }
  hideRiskMakeFlagFun = () => {
    this.setState({
      riskMakeFlag: false
    });
  }
  render() {
    let { SupperFundHome , superFundAccAgreementState,inInvestmentList} = this.props;
    const { hideFlag ,upgradeList,upgradeListAll} = this.state;

    console.log(this.props.inInvestmentList,'***inInvestmentListinInvestmentListinInvestmentList')
    // SupperFundHome = tempData.content;
    let dataViews = SupperFundHome ? SupperFundHome : [];
    let SuperList = SupperFundHome ? (SupperFundHome.singleSuperFundViews ? SupperFundHome.singleSuperFundViews : []) : [];
    let haveSF=SupperFundHome ? (SupperFundHome.singleSuperFundViews!=null ? true:false) : false;
    return (
        <div id='InvestmentIndex' style={{display:'flex',flex:1,overflowY:'scroll',flexDirection:'column',alignItems:'center'}}>
          <div style={{backgroundImage: `url(${require("../imgs/investment_head_bg.png")})`, backgroundSize: "cover", width: window.winWidth, paddingRight:20,paddingLeft:20 }}>
            {/*标题*/}
            <div style={{paddingTop: this.state.flag.indexOf("miniprogram") != -1 ? 33 : 66, display: "-webkit-flex", WebkitFlexDirection: "row", WebkitJustifyContent: "space-between", WebkitAlignItems: "flex-end"}}>
              <div>
                <p style={{fontSize: 24, color: "#333", fontWeight: 500}}>华夏查理智投</p>
              </div>
              <div style={{display: "-webkit-flex", WebkitFlexDirection: "row", WebkitAlignItems: "center"}}>
                <p style={{fontSize: 12, color: "#333"}}>懂投资</p>
                <span style={{width: 2, height: 2, background: "#F92C3D", marginLeft: 6, marginRight: 6}}></span>
                <p style={{fontSize: 12, color: "#333"}}>更懂你</p>
                <img onClick={this.showModalXiaoai} src={require("../imgs/xiaoshuoming.png")} style={{width: 18, height: 18, marginLeft: 4}} />
              </div>
            </div>
            {
              haveSF ?
              <div>
                {/*持仓*/}
                <div style={{marginTop: 10, boxShadow: "0 2px 6px rgba(0, 0, 0, 0.1)", width: window.winWidth - 40, paddingTop: 15, paddingBottom: 15, paddingRight: 15, paddingLeft: 15, backgroundColor: "#fff", borderRadius: 4}}>
                  <div style={{display: "-webkit-flex", WebkitFlexDirection: "row", WebkitJustifyContent: "space-between", WebkitAlignItems: "center"}}>
                    <p style={{fontSize: 12, color: "#999"}}>智投总资产（元）</p>
                    {/*
                      SupperFundHome && SupperFundHome.transitAssets ?
                      <a 
                        href={"javascript:void(0)"} 
                        onClick={() => {this.goTransitRecords()}} 
                        style={{display: "-webkit-flex", WebkitFlexDirection: "row", WebkitAlignItems: "center"}}>
                        <div style={{backgroundColor: "#FFE4E6", paddingRight: 8, paddingLeft: 8, height: 20, borderRadius: 10, display: "-webkit-flex", WebkitAlignItems: "center"}}>
                          <p style={{fontSize: 10, color: "#F92C3D"}}>在途资金{Util.parsePrice(SupperFundHome.transitAssets)}</p>
                        </div>
                        <img src={require("../imgs/c_hxcf_icon_youjiantou_10_grayss.png")} style={{width: 10, height: 10, marginLeft: 2}} />
                      </a>
                      :
                      null
                    */}
                  </div>
                  <a 
                    href={"javascript:void(0)"} 
                    onClick={() => {this.goSuperFundList()}} 
                    style={{marginTop: 8, display: "-webkit-flex", WebkitFlexDirection: "row", WebkitAlignItems: "flex-end"}}>
                    <p style={{fontSize: 20, color: "#333", fontWeight: 400}}>{SupperFundHome && SupperFundHome.totalAssets ? Util.parsePrice((SupperFundHome.totalAssets.toString()).split(".")[0], true) : "--"}</p>
                    <p style={{fontSize: 14, color: "#333", fontWeight: 400}}>{SupperFundHome && SupperFundHome.totalAssets ? (SupperFundHome.totalAssets.toString()).split(".").length == 2 ? "." + ((SupperFundHome.totalAssets.toFixed(2)).toString()).split(".")[1] : ".00" : ""}</p>
                  </a>
                  <div style={{marginTop: 12, backgroundColor: "#F5F5F5", width: window.winWidth - 70, borderRadius: 2, paddingTop: 10, paddingBottom: 10, paddingLeft: 15, paddingRight: 15, display: "-webkit-flex", WebkitFlexDirection: "row"}}>
                    <div style={{display: "-webkit-flex", WebkitFlex: 4, WebkitFlexDirection: "column"}}>
                      <p style={{color: "#999", fontSize: 12}}>最新收益 ({SupperFundHome.deadLine ? SupperFundHome.deadLine : "--"})</p>
                      <p style={{color: SupperFundHome && SupperFundHome.dayIncome ? SupperFundHome.dayIncome > 0 ? "#F92C3D" : "#1EB872" : "#F92C3D", fontSize: 14, fontWeight: 400, marginTop: 5}}>{SupperFundHome && SupperFundHome.dayIncome ? SupperFundHome.dayIncome > 0 ? "+" +  Util.fomatFloat(SupperFundHome.dayIncome) :  Util.fomatFloat(SupperFundHome.dayIncome) : "--"}</p>
                    </div>
                    <div style={{display: "-webkit-flex", WebkitFlex: 3, WebkitFlexDirection: "column"}}>
                      <p style={{color: "#999", fontSize: 12}}>累计收益 (元)</p>
                      <p style={{color: SupperFundHome && SupperFundHome.allIncome ? SupperFundHome.allIncome > 0 ? "#F92C3D" : "#1EB872" : "#F92C3D", fontSize: 14, fontWeight: 400, marginTop: 5}}>{SupperFundHome && SupperFundHome.allIncome ? SupperFundHome.allIncome > 0 ? "+" +  Util.fomatFloat(SupperFundHome.allIncome) : Util.fomatFloat(SupperFundHome.allIncome) : "--"}</p>
                    </div>
                  </div>
                </div>
                {/*banner*/}
                {
                  ua.indexOf("amcfmapp")>-1 ?
                  <div style={{height:40}}>
  
                  </div>
                  :
                  <div style={{backgroundColor: "transparent", width: window.winWidth - 40, marginTop: 25, borderRadius: 4, display: "-webkit-flex", WebkitFlexDirection: "row", WebkitJustifyContent: "space-between", WebkitAlignItems: "center"}}>
                    <a 
                      href={"javascript:void(0)"} 
                      onClick={() => {this.pushZTJS()}} 
                      style={{display: "-webkit-flex", WebkitFlexDirection: "column", WebkitAlignItems: "center"}}>
                      <img src={require("../imgs/eq_mdzt_icon.png")} style={{width: 32, height: 32}} />
                      <p style={{fontSize: 12, color: "#333", marginTop: 5}}>秒懂智投</p>
                    </a>
                    <a 
                      href={"javascript:void(0)"} 
                      onClick={() => {this.pushInvestmentPlan()}} 
                      style={{display: "-webkit-flex", WebkitFlexDirection: "column", WebkitAlignItems: "center"}}>
                      <img src={require("../imgs/eq_zhdt_icon.png")} style={{width: 32, height: 32}} />
                      <p style={{fontSize: 12, color: "#333", marginTop: 5}}>智慧定投</p>
                    </a>
                    <a 
                      href={"javascript:void(0)"} 
                      onClick={() => {this.RiskTest()}} 
                      style={{display: "-webkit-flex", WebkitFlexDirection: "column", WebkitAlignItems: "center"}}>
                      <img src={require("../imgs/eq_lcgh_icon.png")} style={{width: 32, height: 32}} />
                      <p style={{fontSize: 12, color: "#333", marginTop: 5}}>财务规划</p>
                    </a>
                    <a 
                      href={"javascript:void(0)"} 
                      onClick={() => {this.pushWz()}} 
                      style={{display: "-webkit-flex", WebkitFlexDirection: "column", WebkitAlignItems: "center"}}>
                      <img src={require("../imgs/eq_clcsk_icon.png")} style={{width: 32, height: 32}} />
                      <p style={{fontSize: 12, color: "#333", marginTop: 5}}>查理财商课</p>
                    </a>
                  </div>
                }
              </div>
              :
              <div>
                {/*标签*/}
                <div style={{display: "-webkit-flex", WebkitFlexDirection: "row", WebkitAlignItems: "center", paddingTop: 10}}> 
                  <div style={{display: "-webkit-flex", WebkitFlexDirection: "row", WebkitAlignItems: "center"}}>
                    <img src={require("../imgs/icon_dg.png")} style={{width: 12.8, height: 13}} />
                    <p style={{fontSize: 12, color: "#666", marginLeft: 4}}>智能配置</p>
                  </div>
                  <div style={{marginLeft: 15, display: "-webkit-flex", WebkitFlexDirection: "row", WebkitAlignItems: "center"}}>
                    <img src={require("../imgs/icon_dg.png")} style={{width: 12.8, height: 13}} />
                    <p style={{fontSize: 12, color: "#666", marginLeft: 4}}>省心投资</p>
                  </div>
                  <div style={{marginLeft: 15, display: "-webkit-flex", WebkitFlexDirection: "row", WebkitAlignItems: "center"}}>
                    <img src={require("../imgs/icon_dg.png")} style={{width: 12.8, height: 13}} />
                    <p style={{fontSize: 12, color: "#666", marginLeft: 4}}>稳健理财</p>
                  </div>
                </div>
                {/*banner*/}
                {
                   ua.indexOf("amcfmapp")>-1 ?
                   <div style={{height:115}}>
  
                   </div>
                   :
                  <div style={{backgroundColor: "#fff", height: 86, width: window.winWidth - 40, marginTop: 20, borderRadius: 4, boxShadow: "0 2px 6px rgba(0, 0, 0, 0.1)", display: "-webkit-flex", WebkitFlexDirection: "row", WebkitJustifyContent: "space-between", WebkitAlignItems: "center", paddingLeft: 20, paddingRight: 20,marginBottom:10}}>
                    <a 
                      href={"javascript:void(0)"} 
                      onClick={() => {this.pushZTJS()}} 
                      style={{display: "-webkit-flex", WebkitFlexDirection: "column", WebkitAlignItems: "center"}}>
                      <img src={require("../imgs/eq_mdzt_icon.png")} style={{width: 32, height: 32}} />
                      <p style={{fontSize: 12, color: "#333", marginTop: 5}}>秒懂智投</p>
                    </a>
                    <a 
                      href={"javascript:void(0)"} 
                      onClick={() => {this.pushInvestmentPlan()}} 
                      style={{display: "-webkit-flex", WebkitFlexDirection: "column", WebkitAlignItems: "center"}}>
                      <img src={require("../imgs/eq_zhdt_icon.png")} style={{width: 32, height: 32}} />
                      <p style={{fontSize: 12, color: "#333", marginTop: 5}}>智慧定投</p>
                    </a>
                    <a 
                      href={"javascript:void(0)"} 
                      onClick={() => {this.RiskTest()}} 
                      style={{display: "-webkit-flex", WebkitFlexDirection: "column", WebkitAlignItems: "center"}}>
                      <img src={require("../imgs/eq_lcgh_icon.png")} style={{width: 32, height: 32}} />
                      <p style={{fontSize: 12, color: "#333", marginTop: 5}}>财务规划</p>
                    </a>
                    <a 
                      href={"javascript:void(0)"} 
                      onClick={() => {this.pushWz()}} 
                      style={{display: "-webkit-flex", WebkitFlexDirection: "column", WebkitAlignItems: "center"}}>
                      <img src={require("../imgs/eq_clcsk_icon.png")} style={{width: 32, height: 32}} />
                      <p style={{fontSize: 12, color: "#333", marginTop: 5}}>查理财商课</p>
                    </a>
                  </div>
                }
              </div>
            }
            {/*规划*/}
            {/* <div style={{marginTop: 20}}>
              <p style={{fontSize: 18, color: "#27282F", fontWeight: 500}}>开始你的规划</p>
            </div> */}
          </div>
          <div style={{display: "-webkit-flex",marginTop:ua.indexOf("amcfmapp")>-1 && haveSF ? 0 :ua.indexOf("amcfmapp")>-1 && !haveSF ?-80: 20,height:40,alignSelf:'flex-start',marginLeft:20,alignItems:'center'}}>
              <p style={{fontSize: 18, color: "#27282F", fontWeight: 500}}>开始你的规划</p>
          </div>
          {/*规划*/}
          {
            this.state.ifMakePlan && !this.state.isAnswerState ?
            <div style={{backgroundImage: `url(${require("../imgs/home_ZT_card.png")})`, backgroundSize: "cover", width: window.winWidth - 40, minHeight: 200, paddingRight:15,paddingLeft:15, paddingTop: 20}}>
              <div style={{display: "-webkit-flex", WebkitFlexDirection: "row", WebkitJustifyContent: "space-between", WebkitAlignItems: "center"}}>
                <p style={{fontSize: 16, color: "#2C3245", fontWeight: 500}}>不同人生阶段的可能投资需求</p>
                <img src={require("../imgs/home_ZT_card_icon.png")} style={{width: 28, height: 28}} />
              </div>
              <div style={{paddingTop: 10}}>
                <p style={{fontSize: 12, color: "#868DA0", lineHeight: "17px"}}>我们将基于生命周期理论，根据您填写的需求，结合您所处的人生阶段，为您规划合适的投资方案</p>
              </div>
              {
                this.state.userAnswerList.length > 0 && this.state.showHidePlanFlag ?
                <div style={{marginTop: 15, width: window.winWidth - 70, backgroundColor: "#fff", paddingTop: 10, paddingBottom: 15, paddingLeft: 15, paddingRight: 15, borderRadius: 2}}>
                  {
                    this.state.userAnswerList.map((data, index) => {
                      if(data.order == "1") {
                        return (
                          <div key={index + "_" + data.order} style={{display: "-webkit-flex", WebkitFlexDirection: "row", WebkitAlignItems: "center", WebkitJustifyContent: "space-between"}}>
                            <p style={{fontSize: 12, color: "#666"}}>您当前的投资需求</p>
                            <p style={{fontSize: 12, color: "#666"}}>年龄：{data.content}岁</p>
                          </div>
                        )
                      }
                    })
                  }
                  <div style={{backgroundColor: "#EFF0F4", height: 1, width: window.winWidth - 100, marginTop: 15}}></div>
                  {
                    this.state.userAnswerList.map((data, index) => {
                      if(data.order == "2") {
                        return (
                          <div key={index + "_" + data.order}>
                            {
                              data.content.map((dataSec, indexSec) => {
                                if(dataSec.flag) {
                                  return (
                                    <div key={index + "_" + data.order + "_" + indexSec} style={{marginTop: indexSec === 0 ? 10 : 14}}>
                                      <div style={{display: "-webkit-flex", WebkitFlexDirection: "row", WebkitAlignItems: "center", width: "max-content", backgroundColor: "rgba(255, 214, 217, 0.3)", height: 15, borderTopRightRadius: 100, borderTopLeftRadius: 100, borderBottomLeftRadius: 100}}>
                                        <img src={require("../imgs/ZT_checked.png")} style={{width: 12, height: 12}} />
                                        <span style={{fontSize: 10, color: "#F92C3D", fontWeight: 500, marginLeft: 3}}>{dataSec.content.split("：")[0]}：</span>
                                      </div>
                                      <div>
                                        <p style={{fontSize: 12, color: "#333", lineHeight: "17px", marginTop: 2}}>{dataSec.content.split("：")[1]}</p>
                                      </div>
                                    </div>
                                  )
                                }else {
                                  return (
                                    <div key={index + "_" + data.order + "_" + indexSec} style={{marginTop: indexSec === 0 ? 10 : 14}}>
                                      <div style={{display: "-webkit-flex", WebkitFlexDirection: "row", WebkitAlignItems: "center", width: "max-content", backgroundColor: "rgba(230, 230, 230, 0.3)", height: 15, borderTopRightRadius: 100, borderTopLeftRadius: 100, borderBottomLeftRadius: 100}}>
                                        <div style={{width: 12, height: 12, backgroundColor: "#EEEEEE", borderRadius: 100}}></div>
                                        <span style={{fontSize: 10, color: "#999", fontWeight: 500, marginLeft: 3}}>{dataSec.content.split("：")[0]}：</span>
                                      </div>
                                      <div>
                                        <p style={{fontSize: 12, color: "#999", lineHeight: "17px", marginTop: 2}}>{dataSec.content.split("：")[1]}</p>
                                      </div>
                                    </div>
                                  )
                                }
                              })
                            }
                          </div>
                        )
                      }
                    })
                  }
                  {/*
                    this.state.userAnswerList.map((data, index) => {
                      if(data.order == "3") {
                        return (
                          <div key={index + "_" + data.order} style={{height: 20, display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center", backgroundColor: data.content ? "#FFEEF0" : "#DEDEDE", borderRadius: 2, marginTop: 8, width: 100}}>
                            <p style={{fontSize: 11, color: data.content ? "#F92C3D" : "#333"}}>{data.content ? "有" : "无"}行业投资偏好</p>
                          </div>
                        )
                      }
                    })
                  */}
                </div>
                :
                null
              }
              <div style={{display: "-webkit-flex", WebkitFlex: 1, WebkitJustifyContent: "center", WebkitAlignItems: "center", paddingTop: 20, WebkitFlexDirection: "row", paddingBottom: 15}}>
                <div onClick={this.goToMakePlan} style={{width: 122, height: 32, backgroundColor: "transparent", borderRadius: 4, display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center", borderStyle: "solid", borderWidth: 1, borderColor: "#F92C3D"}}>
                  <p style={{fontSize: 14, color: "#F92C3D"}}>重新规划</p>
                </div>
                <div onClick={() => {this.goResultFun(true)}} style={{marginLeft: 20, width: 122, height: 32, backgroundColor: "#F92C3D", borderRadius: 4, display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center"}}>
                  <p style={{fontSize: 14, color: "#fff"}}>查看结果</p>
                </div>
              </div>
              <div style={{marginBottom: 20, width: window.winWidth - 70, textAlign: "center"}} onClick={this.showHidePlan}>
                {
                  this.state.showHidePlanFlag ?
                  <img src={require("../imgs/jiantou_icon.png")} style={{width: 14, height: 14}} />
                  :
                  <img src={require("../imgs/jiantou_icon_sec.png")} style={{width: 14, height: 14}} />
                }
              </div>
            </div>
            :
            <div style={{backgroundImage: `url(${require("../imgs/home_ZT_card.png")})`, backgroundSize: "cover", width: window.winWidth - 40, minHeight: 200, paddingRight:15,paddingLeft:15, paddingTop: 20}}>
              <div style={{display: "-webkit-flex", WebkitFlexDirection: "row", WebkitJustifyContent: "space-between", WebkitAlignItems: "center"}}>
                <p style={{fontSize: 16, color: "#2C3245", fontWeight: 500}}>不同人生阶段的可能投资需求</p>
                <img src={require("../imgs/home_ZT_card_icon.png")} style={{width: 28, height: 28}} />
              </div>
              <div style={{paddingTop: 10}}>
                <p style={{fontSize: 12, color: "#868DA0", lineHeight: "17px"}}>我们将基于生命周期理论，根据您填写的需求，结合您所处的人生阶段，为您规划合适的投资方案</p>
              </div>
              <div>
                {
                  this.state.showHidePlanFlag ?
                  <div style={{display: "-webkit-flex", WebkitFlexDirection: "row", WebkitFlexWrap: "wrap", WebkitJustifyContent: 'space-between', marginTop: 15}}>
                    <div style={{borderRadius: 2, backgroundColor: "#fff", WebkitAlignItems: "flex-start", width: (window.winWidth - 80) / 2, height: 64, display: "-webkit-flex", WebkitFlexDirection: "row", WebkitJustifyContent: "space-between"}}>
                      <p style={{fontSize: 14, color: "#333", marginLeft: 15, marginTop: 15}}>财富成长</p>
                      <img src={require("../imgs/icon_1.png")} style={{width: 44, height: 44}} />
                    </div>
                    <div style={{borderRadius: 2, backgroundColor: "#fff", WebkitAlignItems: "flex-start", width: (window.winWidth - 80) / 2, height: 64, display: "-webkit-flex", WebkitFlexDirection: "row", WebkitJustifyContent: "space-between"}}>
                      <p style={{fontSize: 14, color: "#333", marginLeft: 15, marginTop: 15}}>资产保值</p>
                      <img src={require("../imgs/icon_2.png")} style={{width: 44, height: 44}} />
                    </div>
                    <div style={{borderRadius: 2, marginTop: 10, backgroundColor: "#fff", WebkitAlignItems: "flex-start", width: (window.winWidth - 80) / 2, height: 64, display: "-webkit-flex", WebkitFlexDirection: "row", WebkitJustifyContent: "space-between"}}>
                      <p style={{fontSize: 14, color: "#333", marginLeft: 15, marginTop: 15}}>养老储蓄</p>
                      <img src={require("../imgs/icon_3.png")} style={{width: 44, height: 44}} />
                    </div>
                    <div style={{borderRadius: 2, marginTop: 10, backgroundColor: "#fff", WebkitAlignItems: "flex-start", width: (window.winWidth - 80) / 2, height: 64, display: "-webkit-flex", WebkitFlexDirection: "row", WebkitJustifyContent: "space-between"}}>
                      <p style={{fontSize: 14, color: "#333", marginLeft: 15, marginTop: 15}}>子女教育</p>
                      <img src={require("../imgs/icon_4.png")} style={{width: 44, height: 44}} />
                    </div>
                  </div>
                  :
                  null
                }
                <div style={{display: "-webkit-flex", WebkitFlex: 1, WebkitJustifyContent: "center", WebkitAlignItems: "center", paddingTop: 26, WebkitFlexDirection: "column"}}>
                  <div onClick={this.goToMakePlan} style={{width: 122, height: 32, backgroundColor: "#F92C3D", borderRadius: 4, display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center"}}>
                    <p style={{fontSize: 14, color: "#fff"}}>开启规划</p>
                  </div>
                  {
                    this.state.isAnswerState ?
                    <div style={{display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center", marginTop: 15}}>
                      <p style={{fontSize: 12, color: "#7F8BA3"}}>为提供更优质服务，投顾升级，请重新规划</p>
                    </div>
                    :
                    null
                  }
                  <div style={{marginTop: 15, marginBottom: 20, width: window.winWidth - 70, textAlign: "center"}} onClick={this.showHidePlan}>
                    {
                      this.state.showHidePlanFlag ?
                      <img src={require("../imgs/jiantou_icon.png")} style={{width: 14, height: 14}} />
                      :
                      <img src={require("../imgs/jiantou_icon_sec.png")} style={{width: 14, height: 14}} />
                    }
                  </div>
                </div>
              </div>
            </div>
          }
          {/*跳转组合*/}
          {
            this.state.showFundFlag ?
            <div style={{width: window.winWidth - 40, marginTop: 30, backgroundColor: "#FFF6F6", paddingLeft: 8, paddingRight: 15, paddingTop: 8, paddingBottom: 8, borderRadius: 4, display: "-webkit-flex", WebkitFlexDirection: "row", WebkitAlignItems: "flex-start"}}>
              <img src={require("../imgs/kyc_zt_mqmb_icon.png")} style={{width: 17, height: 18}} />
              <p style={{fontSize: 12, color: "#333", lineHeight: "20px", marginLeft: 2}}>您对本次投资有较为明确的目标，华夏财富为您提供如下基金投顾组合，您可自主选择。</p>
            </div>
            :
            <div style={{paddingBottom: 20}}>
              <div onClick={() => {this.goResultFun(false)}} style={{boxShadow: "0 2px 6px rgba(0, 0, 0, 0.1)", width: window.winWidth - 40, height: 50, display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center", backgroundColor: "#fff", WebkitFlexDirection: "row", borderRadius: 4, marginTop: 20}}>
                <p style={{fontSize: 14, color: "#2C3245"}}>我有明确投资目标，希望直接挑选组合</p>
                <img src={require("../imgs/xiaoicon_shuoming.png")} style={{width: 16, height: 16, marginLeft: 5}} />
              </div>
            </div>
          }
          {
            this.state.showFundFlag ?
            <div style={{paddingLeft: 20, paddingRight: 20}}>
              <div style={{width: window.winWidth - 40, overflowX: "auto"}}>
                <div style={{display: "-webkit-flex", WebkitFlexDirection: "row", WebkitAlignItems: "center", paddingTop: 15}}>
                  {
                    this.state.mateFundList.map((data, index) => {
                      if(data.superFundList && data.superFundList.length > 0) {
                        return (
                          <div onClick={() => {this.ckTab(data.seriesId, data.seriesName)}} key={index} style={{height: 30, backgroundColor: this.state.seriesId == data.seriesId ? "#FFE9EB" : "#F3F3F3", paddingLeft: 10, paddingRight: 10, display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center", borderRadius: 15, whiteSpace: "pre", marginLeft: index === 0 ? 0 : 10}}>
                            <p style={{fontSize: 14, color: this.state.seriesId == data.seriesId ? "#F92C3D" : "#666"}}>{data.seriesName}</p>
                          </div>
                        )
                      }
                    })
                  }
                </div>
              </div>
              {
                this.state.mateFundList.map((data, index) => {
                  if(data.superFundList && data.superFundList.length > 0 && data.seriesId == this.state.seriesId) {
                    return (
                      <div key={index} style={{paddingTop: 20, display: "-webkit-flex", width: window.winWidth - 40, WebkitJustifyContent: "center"}}>
                        <div style={{position: "relative", backgroundColor: "#fff", borderRadius: 4, boxShadow: "0 2px 6px rgba(0, 0, 0, 0.1)", paddingTop: 15, paddingBottom: 15, paddingLeft: 15, paddingRight: 15, width: window.winWidth - 40, minHeight: 178.78}}>
                          <div>
                            <p style={{fontSize: 16, color: "#2C3245", fontWeight: 500}}>{data.seriesName}</p>
                          </div>
                          {
                            data.superFundList.map((dataSec, indexSec) => {
                              let colorSyl = "#F92C3D";
                              if(dataSec.fullOneYear) {
                                if(Util.returnEmpty(dataSec.rate, "%") == "--%") {
                                  colorSyl = "#333";
                                }else {
                                  if(dataSec.rate < 0) {
                                    colorSyl = "rgba(54, 169, 99, 1)";
                                  }else {
                                    colorSyl = "#F92C3D";
                                  }
                                }
                              }else {
                                colorSyl = "#333";
                              }
                              return (
                                <div onClick={() => {this.investNotDetil(dataSec)}} key={indexSec + "_" + data.seriesId}>
                                  <div style={{paddingTop: 20}}>
                                    <p style={{fontSize: 14, color: "#333"}}>{dataSec.superFundName}</p>
                                  </div>
                                  <div style={{marginTop: 15, display: "-webkit-flex", WebkitFlexDirection: "row", }}>
                                    <div style={{display: "-webkit-flex", WebkitFlex: 1, WebkitFlexDirection: "column"}}>
                                      <p style={{fontSize: 18, color: colorSyl, fontWeight: 400, lineHeight: '20px'}}>{dataSec.fullOneYear ? Util.returnEmpty(dataSec.rate, "%") : "--%"}</p>
                                      <p style={{fontSize: 11, color: "#666", marginTop: 5}}>{ua.indexOf("amcfmapp")>-1 ? "成立以来年化涨跌幅" : dataSec.rateTypeName}</p>
                                    </div>
                                    <div style={{display: "-webkit-flex", WebkitFlex: 1, WebkitFlexDirection: "column"}}>
                                      <p style={{fontSize: 18, color: "#333", fontWeight: 400, lineHeight: '20px'}}>{dataSec.holdTime}</p>
                                      <p style={{fontSize: 11, color: "#666", marginTop: 5}}>{dataSec.hold}</p>
                                    </div>
                                  </div>
                                  <div style={{marginTop: 10, backgroundColor: "#F5F5F5", paddingTop: 8, paddingBottom: 8, paddingLeft: 10, paddingRight: 10, borderRadius: 2}}>
                                    <p style={{fontSize: 11, color: "#666"}}>特点：{dataSec.feature}</p>
                                  </div>
                                  {
                                    data.superFundList.length - 1 === indexSec ? 
                                    null 
                                    :
                                    <div style={{marginTop: 20, backgroundColor: "#EFF0F4", height: 1, width: window.winWidth - 40}}></div>
                                  }
                                </div>
                              )
                            })
                          }
                        </div>
                      </div>
                    )
                  }else {
                    return (
                      <div key={index}></div>
                    )
                  }
                })
              }
            </div>
            :
            null
          }
          {
            this.state.showFundFlag ?
            <div style={{width: window.winWidth, paddingLeft: 20, paddingRight: 20, paddingTop: 20, paddingBottom: 40, backgroundColor: "#F8F8F8", marginTop: 20}}>
              <p style={{fontSize: 12, color: "#999", lineHeight: "17px"}}>以上内容仅用作了解您的投资目标，不对投顾策略的收益及回撤控制有任何保证。成立以来年化收益等历史业绩仅作为参考，不预示组合未来表现。基金投资组合策略的风险特征与单只基金产品的风险特征存在差异；投资者自主选择投顾组合，承担市场波动带来的损失；为其他客户创造的收益并不构成业绩表现的保证。</p>
            </div>
            :
            null
          }
          {/*风险提示*/}
          {
            this.state.riskModalFir ?
            <div style={{position: "fixed", top: 0, bottom: 0, left: 0, width: window.winWidth, backgroundColor: "rgba(0, 0, 0, 0.6)", display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center"}}>
              <div style={{width: 295, paddingBottom: 20, borderRadius: 4, backgroundColor: "#fff"}}>
                <div style={{paddingTop: 20, display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center"}}>
                  <p style={{fontSize: 18, color: "#333", fontWeight: 500}}>风险提示</p>
                </div>
                <div style={{paddingTop: 12, display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center" , paddingLeft: 20, paddingRight: 20}}>
                  <p style={{fontSize: 14, color: "#333", lineHeight: "20px"}}>为您规划的方案中部分产品的风险等级与您的风险承受能力不符，请确认是否全部查看</p>
                </div>
                <div style={{paddingTop: 15, display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center", WebkitFlexDirection: "row"}}>
                  <div onClick={this.showRiskMakeFunFir} style={{display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center", borderStyle: "solid", borderWidth: 1, borderColor: "#F92C3D", backgroundColor: "transparent", width: 122, height: 32, borderRadius: 4}}>
                    <p style={{fontSize: 14, color: "#F92C3D"}}>部分查看</p>
                  </div>
                  <div onClick={() => {this.showAllFundListFir(true, this.state.allStrategyList, "全部")}} style={{display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center", backgroundColor: "#F92C3D", marginLeft: 10, width: 122, height: 32, borderRadius: 4}}>
                    <p style={{fontSize: 14, color: "#fff"}}>全部查看</p>
                  </div>
                </div>
              </div>
            </div>
            :
            null
          }
          {/*风险提示*/}
          {
            this.state.riskModalSec ?
            <div style={{position: "fixed", top: 0, bottom: 0, left: 0, width: window.winWidth, backgroundColor: "rgba(0, 0, 0, 0.6)", display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center"}}>
              <div style={{width: 295, paddingBottom: 20, borderRadius: 4, backgroundColor: "#fff"}}>
                <div style={{paddingTop: 20, display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center"}}>
                  <p style={{fontSize: 18, color: "#333", fontWeight: 500}}>风险提示</p>
                </div>
                <div style={{paddingTop: 12, display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center" , paddingLeft: 20, paddingRight: 20}}>
                  <p style={{fontSize: 14, color: "#333", lineHeight: "20px"}}>部分产品的风险等级与您的风险承受能力不符，请确认是否全部查看</p>
                </div>
                <div style={{paddingTop: 15, display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center", WebkitFlexDirection: "row"}}>
                  <div onClick={this.showRiskMakeFunSec} style={{display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center", borderStyle: "solid", borderWidth: 1, borderColor: "#F92C3D", backgroundColor: "transparent", width: 122, height: 32, borderRadius: 4}}>
                    <p style={{fontSize: 14, color: "#F92C3D"}}>部分查看</p>
                  </div>
                  <div onClick={() => {this.showAllFundListSec("")}} style={{display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center", backgroundColor: "#F92C3D", marginLeft: 10, width: 122, height: 32, borderRadius: 4}}>
                    <p style={{fontSize: 14, color: "#fff"}}>全部查看</p>
                  </div>
                </div>
              </div>
            </div>
            :
            null
          }
          {/*重新测评*/}
          {
            this.state.riskMakeFlag ?
            <div style={{position: "fixed", top: 0, bottom: 0, left: 0, width: window.winWidth, backgroundColor: "rgba(0, 0, 0, 0.6)", display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center"}}>
              <div style={{width: 295, paddingBottom: 20, borderRadius: 4, backgroundColor: "#fff"}}>
                <div style={{paddingTop: 20, display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center"}}>
                  <p style={{fontSize: 18, color: "#333", fontWeight: 500}}>风险提示</p>
                </div>
                <div style={{paddingTop: 12, display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center" , paddingLeft: 20, paddingRight: 20}}>
                  <p style={{fontSize: 14, color: "#333", lineHeight: "20px"}}>尊敬的用户，您选择了部分查看，已为您屏蔽掉风险不匹配的组合策略，屏蔽后，暂无匹配您需求的投顾组合。如您的风险承受能力发生变化，请重新进行风险测评。</p>
                </div>
                <div style={{paddingTop: 15, display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center", WebkitFlexDirection: "row"}}>
                  <div onClick={this.hideRiskMakeFlagFun} style={{display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center", borderStyle: "solid", borderWidth: 1, borderColor: "#F92C3D", backgroundColor: "transparent", width: 122, height: 32, borderRadius: 4}}>
                    <p style={{fontSize: 14, color: "#F92C3D"}}>取消</p>
                  </div>
                  <div onClick={this.resetRiskFun} style={{display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center", backgroundColor: "#F92C3D", marginLeft: 10, width: 122, height: 32, borderRadius: 4}}>
                    <p style={{fontSize: 14, color: "#fff"}}>重新测评</p>
                  </div>
                </div>
              </div>
            </div>
            :
            null
          }
          {/*重新规划*/}
          {
            this.state.nothingFlagFir ?
            <div style={{position: "fixed", top: 0, bottom: 0, left: 0, width: window.winWidth, backgroundColor: "rgba(0, 0, 0, 0.6)", display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center"}}>
              <div style={{width: 295, paddingBottom: 20, borderRadius: 4, backgroundColor: "#fff"}}>
                <div style={{paddingTop: 20, display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center"}}>
                  <p style={{fontSize: 18, color: "#333", fontWeight: 500}}>风险提示</p>
                </div>
                <div style={{paddingTop: 12, display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center" , paddingLeft: 20, paddingRight: 20}}>
                  <p style={{fontSize: 14, color: "#333", lineHeight: "20px"}}>尊敬的用户，基于您的需求，暂未能为您匹配出投顾组合。</p>
                </div>
                <div style={{paddingTop: 15, display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center", WebkitFlexDirection: "row"}}>
                  <div onClick={this.goToMakePlan} style={{display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center", backgroundColor: "#F92C3D", marginLeft: 10, width: 122, height: 32, borderRadius: 4}}>
                    <p style={{fontSize: 14, color: "#fff"}}>重新规划</p>
                  </div>
                </div>
              </div>
            </div>
            :
            null
          }
          {/*重新规划*/}
          {
            this.state.riskMakeSecFlag ?
            <div style={{position: "fixed", top: 0, bottom: 0, left: 0, width: window.winWidth, backgroundColor: "rgba(0, 0, 0, 0.6)", display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center"}}>
              <div style={{width: 295, paddingBottom: 20, borderRadius: 4, backgroundColor: "#fff"}}>
                <div style={{paddingTop: 20, display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center"}}>
                  <p style={{fontSize: 18, color: "#333", fontWeight: 500}}>风险提示</p>
                </div>
                <div style={{paddingTop: 12, display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center" , paddingLeft: 20, paddingRight: 20}}>
                  <p style={{fontSize: 14, color: "#333", lineHeight: "20px"}}>尊敬的用户，您选择了部分查看，已为您屏蔽掉风险不匹配的组合策略，屏蔽后，暂无匹配您需求的投顾组合。</p>
                </div>
                <div style={{paddingTop: 15, display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center", WebkitFlexDirection: "row"}}>
                  <div onClick={this.goToMakePlan} style={{display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center", backgroundColor: "#F92C3D", marginLeft: 10, width: 122, height: 32, borderRadius: 4}}>
                    <p style={{fontSize: 14, color: "#fff"}}>重新规划</p>
                  </div>
                </div>
              </div>
            </div>
            :
            null
          }
          {/*重新测评*/}
          {
            this.state.nothingFlagSec ?
            <div style={{position: "fixed", top: 0, bottom: 0, left: 0, width: window.winWidth, backgroundColor: "rgba(0, 0, 0, 0.6)", display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center"}}>
              <div style={{width: 295, paddingBottom: 20, borderRadius: 4, backgroundColor: "#fff"}}>
                <div style={{paddingTop: 20, display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center"}}>
                  <p style={{fontSize: 18, color: "#333", fontWeight: 500}}>风险提示</p>
                </div>
                <div style={{paddingTop: 12, display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center" , paddingLeft: 20, paddingRight: 20}}>
                  <p style={{fontSize: 14, color: "#333", lineHeight: "20px"}}>尊敬的用户，基于您的需求，暂未能为您匹配出投顾组合。</p>
                </div>
                <div style={{paddingTop: 15, display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center", WebkitFlexDirection: "row"}}>
                  <div onClick={this.resetRiskFun} style={{display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center", backgroundColor: "#F92C3D", marginLeft: 10, width: 122, height: 32, borderRadius: 4}}>
                    <p style={{fontSize: 14, color: "#fff"}}>重新测评</p>
                  </div>
                </div>
              </div>
            </div>
            :
            null
          }
          {
            this.state.questionModal ?
            <div style={{position: "fixed", top: 0, bottom: 0, left: 0, width: window.winWidth, backgroundColor: "rgba(0, 0, 0, 0.6)", display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center"}}>
              <div style={{width: 295, paddingBottom: 20, borderRadius: 4, backgroundColor: "#fff"}}>
                <div style={{paddingTop: 20, display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center"}}>
                  <p style={{fontSize: 18, color: "#333", fontWeight: 500}}>风险提示</p>
                </div>
                <div style={{paddingTop: 12, display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center" , paddingLeft: 20, paddingRight: 20}}>
                  <p style={{fontSize: 14, color: "#333", lineHeight: "20px"}}>当前您还未进行风险测评或风险测评已过期，请您完成测评后再继续操作。</p>
                </div>
                <div style={{paddingTop: 15, display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center", WebkitFlexDirection: "row"}}>
                  <div onClick={this.hideQuestionModal} style={{display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center", borderStyle: "solid", borderWidth: 1, borderColor: "#F92C3D", backgroundColor: "transparent", width: 122, height: 32, borderRadius: 4}}>
                    <p style={{fontSize: 14, color: "#F92C3D"}}>暂不测评</p>
                  </div>
                  <div onClick={this.quertionModalFun} style={{display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center", backgroundColor: "#F92C3D", marginLeft: 10, width: 122, height: 32, borderRadius: 4}}>
                    <p style={{fontSize: 14, color: "#fff"}}>风险测评</p>
                  </div>
                </div>
              </div>
            </div>
            :
            null
          }
          {
            this.state.modalXai ? 
            <div style={{width: window.winWidth, bottom: 0, backgroundColor: "rgba(0, 0, 0, 0.5)", WebkitFlex: 1, WebkitJustifyContent: "center", WebkitAlignItems: "center", position: "fixed", left: 0, top: 0, zIndex: 99999999, display: "-webkit-flex"}}>
            <div style={{WebkitFlexDirection: "column", width: 300, backgroundColor: "#fff", borderRadius: 20, WebkitAlignItems: "center",  display: "-webkit-flex"}}>
              <div style={{display: "-webkit-flex", WebkitFlex: 1, WebkitAlignItems: "center", WebkitFlexDirection: "column"}}>
                <span style={{fontSize: 16, marginTop: 20, lineHeight: "22px", color: "#474747", paddingLeft: 20, paddingRight: 20,fontWeight:"500"}}>{"华夏查理智投依托于华夏财富多年的投顾服务经验，基于您在不同人生阶段的财富目标，通过智能化的算法模型为您匹配定制化财富管理方案，一站式满足您的资产保值、财富成长、品质养老、子女教育等场景需求。"}</span>
                <span style={{fontSize: 16,  lineHeight: "22px", color: "#474747", paddingLeft: 20, paddingRight: 20,fontWeight:"500"}}>{"我们希望通过专业化、场景化的基金投顾服务，帮助您降低筛选基金的门槛，并通过全程暖心陪伴服务，帮助您坚定地长期持有，将优选基金的业绩转化为您的实际回报，让您在投资过程中更省心、更安心。"}</span>
                  <div onClick={this.closeModalXai} style={{width:"100%", height:"40px", textAlign:"center", lineHeight:"40px",borderTopColor:"#ebeef0",borderTopWidth:"1px",borderTopStyle:"solid",marginTop:"15px"}}>
                    <div style={{WebkitFlex: 1, WebkitJustifyContent: "center", WebkitAlignItems: "center", display: "-webkit-flex", height: "100%"}}>
                    <span style={{fontSize:17,color:'#666666'}}>知道了</span>
                    </div>
                  </div> 
                </div>
              </div>           
            </div> 
            : 
            null
          }
          {
            superFundAccAgreementState || inInvestmentList.content.records.length > 0  ? 
            <AlerModleQy handleClick1={  this.handleArgee.bind(this) } handleClick2={  this.handleDisagree.bind(this) } /> : null
          }
          {
            this.state.disAgreeAlertFlag ? <AlerModleCommon btnTxt1="返回签约页面"
              btnTxt2="知道了，暂不签约"
              content={"根据监管要求，只能对签约的客户提供基金投顾服务。如未及时签约，华夏财富将无法再为您提供自动调仓等服务，您可选择继续持有当前份额或赎回。"} 
              title="签约提醒"
              handleClick1 = { this.callBackQy.bind(this) }
              handleClick2 = { this.closeDisAgreeAlert.bind(this) }
            /> : null
          }
          {
            this.props.signingAlreadyState!=null&&this.props.signingAlreadyState.state =="1"&&this.props.upgradeControl?
            // this.state.upgradeFlag?
            <AlerModleUpgrade btnTxt1="立即升级"
              btnTxt2="暂不升级"
              content={`${upgradeList.join('、')}`} 
              title="组合升级"
              handleClick1 = { this.pushUpdate.bind(this) }
              handleClick2 = { this.handleCancleUpgrade.bind(this) }
            />:null
          }
          {
            this.state.disupgradeFlag?
             <AlerModleCommon btnTxt1="返回升级页面"
             btnTxt2="知道了，暂不升级"
             content={"组合升级后您可享受基金投顾服务，建议您及时进行组合升级。另外，您也可以在组合持仓页面进行组合升级。"} 
             title="组合升级"
             handleClick1 = { this.handleBackUpgrade.bind(this) }
             handleClick2 = { this.handleNoUpgrade.bind(this) }
           /> : null
          }
          <ModalSelectTip  onOK={()=>{sessionStorage.setItem('first_enter',true);this.setState({firstFlag:false})}} flag={this.state.firstFlag} height={240} title = '基金投资顾问业务提示' rightButtonTitle='我已知晓'   />
          {/*<textarea value={this.state.thisText} cols={40} rows={50} style={{ paddingLeft: 10, paddingRight: 10, fontSize: 15, whiteSpace: "break-spaces"}} >
            
          </textarea>*/}
        </div>
    );
  }
}


 






function mapStateToProps(state, ownProps) {
  return {
    QueryTransitRecords:state.QueryTransitRecords,
    SupperFundHome:state.SupperFundHome,
    superFundAccAgreementState:state.superFundAccAgreementState,
    inInvestmentList:state.InvestPlanReducer.inInvestmentList,
    signingAlreadyState:state.signingAlreadyState,
    upgradeControl:state.upgradeControl
  }
}
export default connect(mapStateToProps)(CacheHOC(Investment,'InvestmentIndex'));


// WEBPACK FOOTER //
// ./src/components/Investment.js